function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.8253 5.42824C20.682 5.65882 21.3574 6.33412 21.5881 7.19059C22.0164 8.75529 21.9999 12.0165 21.9999 12.0165C21.9999 12.0165 21.9999 15.2612 21.5881 16.8259C21.3574 17.6824 20.682 18.3576 19.8253 18.5882C18.2602 19 12 19 12 19C12 19 5.75616 19 4.17462 18.5718C3.31795 18.3412 2.6425 17.6659 2.41186 16.8094C2 15.2612 2 12 2 12C2 12 2 8.75529 2.41186 7.19059C2.6425 6.33412 3.33443 5.64235 4.17462 5.41176C5.73969 5 12 5 12 5C12 5 18.2602 5 19.8253 5.42824ZM10.0066 9.00236L15.2125 12L10.0066 14.9977V9.00236Z"
});

var SvgYoutube = function SvgYoutube(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYoutube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Youtube.24f3e986.svg";
export { ForwardRef as ReactComponent };